export default "__VITE_ASSET__CphN_XB9__"